import * as ng from 'angular';

import {ActivityLogService} from '.';
import {FilterService, FilterServiceFactory} from '../../shared';

export class ActivityLogController implements ng.IController {
   filter:FilterService;
   model:{
      total:number,
      list:any[]
   };

   orgs:any[];

   static $inject = [
      'ActivityLogService', 'filterServiceFactory', 'loader', 'titleService', 'session'
   ];

   constructor(
      private activityLogService:ActivityLogService,
      filterServiceFactory:FilterServiceFactory,
      private loader,
      titleService,
      private session
   ) {
      titleService.setTitle('User Activity Logs');

      this.filter = filterServiceFactory({
         key: 'activity-log',
         defaults: {
            orderBy: '-created',
            orgId: this.session.getOrg().id,
            page: 1,
            limit: 20
         },
         properties: ['search', 'startDate', 'endDate'],
         callback: (property) => this.load()
      });

      this.orgs = this.session.getOrgs();

      this.load();
   }

   load() {
      this.loader.showSpinner();

      this.activityLogService.list(this.filter.inputs)
         .finally(() => this.loader.hide())
         .then((data) => {
            this.model = data;
         });
   }
}

ng.module('e360')
   .controller('ActivityLogController', ActivityLogController);
